<mat-accordion>
    <mat-expansion-panel *ngFor="let p of progression, let i = index">
        <mat-expansion-panel-header>
            <mat-panel-title>
                <strong [style.margin.px]="'auto 0'"> {{p.support.supportName}}</strong>
            </mat-panel-title>
            <mat-panel-description class="img_support" *ngIf="getImg(p?.niveaux) !== null">
                <img [src]="getImg(p?.niveaux)">
            </mat-panel-description>
        </mat-expansion-panel-header>
        <mat-accordion *ngIf="p.niveaux">
            <mat-expansion-panel *ngFor="let n of p.niveaux">
                <mat-expansion-panel-header [style.font-weight]="'bold'" class="sub_level">
                    <mat-panel-title [style.width.%]="50" class="panel_title">
                        <span class="level_color"
                            [style.background-color]="n.couleurs.length < 2 ? n.couleurs[0] : null ">
                            <span id="triangle1" *ngIf="n.couleurs.length >1"
                                [style.border-top-color]="n.couleurs[0]"></span>
                            <span id="triangle2" *ngIf="n.couleurs.length >1"
                                [style.border-bottom-color]="n.couleurs[1]"></span>
                        </span>
                        <p [style.font-size.em]=".9"> {{getLevelString(n.nom)}}</p>
                    </mat-panel-title>
                    <mat-panel-description [style.width.%]="50">
                        <p [style.font-size.em]=".8">{{n.description}}</p>
                    </mat-panel-description>
                </mat-expansion-panel-header>

                <mat-accordion *ngIf=" n.categories" [style.margin-top.px]="10">
                    <mat-expansion-panel *ngFor="let c of n.categories">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <div class="title_category">
                                    <p>{{c.nom}} </p>
                                    <!-- <fa-icon [icon]="faCheckCircle"
                                        [ngClass]="{valid: isValid(c.objectifs[0]), not_valid: !isValid(c.objectifs[0])}">
                                    </fa-icon> -->
                                </div>
                            </mat-panel-title>

                        </mat-expansion-panel-header>
                        <ng-container *ngFor="let o of c.objectifs">
                            <h5><strong>{{o.objectifName}}</strong></h5>
                            <div class="objectifs">
                                <ng-container *ngFor="let so of o.sousObjectifs">
                                    <p>
                                        <fa-icon [icon]="faCheckCircle"
                                            [ngClass]="{valid: (so.validation !== null  && so.validation.dateValidation !== null),  not_valid: (so.validation === null  || so.validation.dateValidation === null)}">
                                        </fa-icon>
                                        {{so.sousObjectifName}}
                                    </p>
                                    <p class="objectif_date"
                                        *ngIf="(so.validation !== null  && so.validation.dateValidation !== null)">
                                        Délivré le
                                        <strong> {{so.validation?.dateValidation | date}}</strong>
                                    </p>
                                </ng-container>
                            </div>
                        </ng-container>

                    </mat-expansion-panel>

                </mat-accordion>

            </mat-expansion-panel>

        </mat-accordion>
    </mat-expansion-panel>

</mat-accordion>